/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Txt from '../atoms/Txt';
import VerSpacer from '../atoms/VerSpacer';
import Row from '../atoms/FlexRow';
import Col from '../atoms/FlexColumn';
import NewAddress from './NewAddress';

const Address = ({ address: addressData, onChange }) => {
  const [editing, setEditing] = useState(false);
  const [newAddress, setNewAddress] = useState();

  const onEditing = () => {
    if (editing) onChange(newAddress);
    setEditing(!editing);
  };

  return (
    <Row justify="space-between" align="flex-start">
      <Col align="flex-start">
        {editing ? (
          <NewAddress data={addressData} onNewAddress={setNewAddress} />
        ) : (
          <>
            <Txt>
              {addressData.address}, Nº {addressData.number}, {addressData.district}
            </Txt>
            <Txt>{addressData.complement}</Txt>
            <Txt>
              {addressData.city} - {addressData.state}
            </Txt>
            <Txt>{addressData.zip}</Txt>
          </>
        )}

        <VerSpacer size={20} />
      </Col>
      <i
        className={editing ? 'fas fa-check' : 'fas fa-pencil-alt'}
        style={{ fontSize: 40 }}
        onClick={onEditing} />
    </Row>
  );
};

export default Address;
